import React, { useState } from "react";
import PropTypes from "prop-types";
import axiosInstance from "../../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../../routes/routes";
import { useNavigate } from "react-router-dom";

const DetailsTable = ({
  headers,
  data=[],
  keyMapping,
  currentPage,
  handleViewButton = () => {},
  handleClicableRow = () => {},
  handleEditClick,
  POID,
  handleSave,
  editRowId,
  editedQuantity,
 
  updateIcon,
}) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [quantities, setQuantities] = useState({});
  const token = localStorage.getItem("authToken");
  const sanitizedData = Array.isArray(data) ? data : [];
  const navigate = useNavigate();
console.log("datadetails",data);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((row) => row.item_id));
    }
    setSelectAll(!selectAll);
  };

  const handleRowSelect = (rowId) => {
    let updatedSelectedRows;
    if (selectedRows.includes(rowId)) {
      updatedSelectedRows = selectedRows.filter((id) => id !== rowId);
    } else {
      updatedSelectedRows = [...selectedRows, rowId];
    }

    setSelectedRows(updatedSelectedRows);
    if (updatedSelectedRows.length === data.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  const handleQuantityChange = (e, rowId) => {
    setQuantities({ ...quantities, [rowId]: e.target.value });
  };

  const handleSubmit = async () => {
    const orderPayload = selectedRows.map((rowId) => {
      const selectedRowData = data.find((row) => row.logistic_stock_id === rowId);
      console.log("selectedRowData",selectedRowData);
      
      return {
        po_id: POID,
        product_id: selectedRowData.product_id,
        subproduct_id: selectedRowData.subproduct_id,
        variant_id: selectedRowData.variant_id,
        itemtype_id: selectedRowData.itemtype_id,
        itemtype: selectedRowData.itemtype,
        item_id: selectedRowData.item_id,
        unit_id: selectedRowData.unit_id,
        rate: selectedRowData.purchase_price,
        taxset_id: 1,
        tax: 0.18,
        taxset_amount:
          selectedRowData.purchase_price * (quantities[rowId] || 1) * 0.18,
        quantity: quantities[rowId] || 1, // Default quantity to 1 if not provided
        totalprice:
          selectedRowData.purchase_price * (quantities[rowId] || 1) * 1.18,
        vendor_onboard_id: selectedRowData.vendor_on_board_id,
        make_id: selectedRowData?.make_id,
        model_id: selectedRowData?.model_id,
      };
    });

    try {
      const response = await axiosInstance.post(
        "/podetails/createpartspecificPodetails",
        orderPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      navigate(ROUTES_NAVIGATION.PURCHASEORDER);
    } catch (error) {
      console.error("Error submitting order:", error);
    }
  };

  return (
    <>
      <div className="logisticstable-container">
        <table className="custom-table">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
              </th>
              {headers?.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sanitizedData?.map((row, rowIndex) => {
              const rowId = row.logistic_stock_id;
              const totalPrice = row.purchase_price * (quantities[rowId] || 1) * 1.18;

              return (
                <tr key={rowId} onClick={() => handleClicableRow(row)}>
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(rowId)}
                      onChange={() => handleRowSelect(rowId)}
                      onClick={(e) => e.stopPropagation()} // Prevent row click on checkbox click
                    />
                  </td>
                  {headers?.map((header, colIndex) => {
                    const key = keyMapping[header];

                    if (header === "Action") {
                      return (
                        <td key={colIndex}>
                          {key.map((action, actionIndex) => (
                            <img
                              key={actionIndex}
                              src={
                                rowId === editRowId && action.type === "edit"
                                  ? updateIcon
                                  : action.icon
                              }
                              style={{ gap: 5, marginLeft: 10 }}
                              data-tip={action.label}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (
                                  action.type === "edit" &&
                                  rowId !== editRowId
                                ) {
                                  handleEditClick(row); // Enter edit mode for this row
                                } else if (updateIcon) {
                                  handleSave(row); // Save changes for this row
                                } else if (action.type === "view") {
                                  handleViewButton(row);
                                }
                              }}
                              className="action-icon"
                            />
                          ))}
                        </td>
                      );
                    }

                    if (header === "Order Quantity" && selectedRows.includes(rowId)) {
                      return (
                        <td key={colIndex}>
                          <input
                            type="number"
                            value={quantities[rowId] || ""}
                            onChange={(e) => handleQuantityChange(e, rowId)}
                            style={{
                              width: "56px",
                              height: "28px",
                              padding: "4px",
                              fontSize: "14px",
                              fontWeight: "500",
                              borderRadius: "4px",
                              border: "2px solid #7BD755",
                              paddingLeft: "10px",
                            }}
                          />
                        </td>
                      );
                    }

                    if (header === "Total Price") {
                      return <td key={colIndex}>{totalPrice.toFixed(2)}</td>;
                    }

                    return <td key={colIndex}>{row[key]}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="btncontainer mt-3">
        <button className="submit-btn" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </>
  );
};

DetailsTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  keyMapping: PropTypes.object.isRequired,
  handleEditClick: PropTypes.func.isRequired,
  handleQuantityChange: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  editRowId: PropTypes.number,
  editedQuantity: PropTypes.object.isRequired,
};

DetailsTable.defaultProps = {
  itemsPerPage: 10,
  isAllocation: false,
};

export default DetailsTable;
